module.exports = __webpack_public_path__ + "static/media/ET188-3new.743883d7.jpg";